import type File from '../../interfaces/File';
import type FailedFile from '../../interfaces/FailedFile';

export interface FilesMovePartitionResult {
  movedFiles: File[];
  failedFiles: FailedFile[];
}

/** Splits the selected files into moved vs failed using API `failedFilesList` entries. */
export function partitionFilesByMoveResult(
  filesToMove: File[],
  failedFilesList?: FailedFile[],
): FilesMovePartitionResult {
  const failedFiles = failedFilesList ?? [];
  if (failedFiles.length === 0) {
    return { movedFiles: filesToMove, failedFiles: [] };
  }

  const failedFileIds = new Set(failedFiles.map((failedFile) => failedFile.fileId));
  return {
    movedFiles: filesToMove.filter((file) => !failedFileIds.has(file.id)),
    failedFiles,
  };
}
